import React, { FC, useState } from "react";
import { nb } from "date-fns/locale";

import { useLabels } from "../Hooks/useLabels";
import { capitalize } from "../Helpers";

import { FourthStepInfoContainer } from "../FormElements";
import { CancellationMessage } from "../CancellationMessage/CancellationMessage";

import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { WaitlistViewModel } from "../../../Blocks/Waitlist/WaitlistViewModel.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { SpecializationDto } from "@apiModels/SpecializationDto.csharp";
import { PricingSummaryModal } from "../FormElements/PopUps/PricingSummaryModal";
import { calculateTotalPrice } from "../Helpers/totalPriceCalculator";
import { PriceDetailsButton } from "../PriceDetailsButton/PriceDetailsButton";
import { format } from "date-fns";
import { ServicePricingSummary } from "../../../Partials/PricingHighlight/ServicePricingSummary.csharp";

type FormAppointmentDetailsProps = {
  appointment: AppointmentDto;
  service: ServiceDto;
  specialization: SpecializationDto;
  doctor?: DoctorDto;
  center: LocationDto;
  displayHeading?: boolean;
  waitlist?: WaitlistViewModel;
  pricingSummary: ServicePricingSummary;
  cancellationMessage: string;
  modal: any;
};

export const FormAppointmentDetails: FC<FormAppointmentDetailsProps> = ({
  appointment,
  service,
  specialization,
  doctor,
  center,
  displayHeading = true,
  waitlist,
  pricingSummary,
  cancellationMessage,
  modal,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const appointmentStartTime = new Date(appointment.startTime);
  const [showPricingSummaryModal, setShowPricingSummaryModal] = useState(false);
  const formattedDate = capitalize(
    format(appointmentStartTime, "eeee d'.' MMMM", { locale: nb })
  );
  const isWaitlist = !!waitlist?.contentId;
  const showPricingSummary = !!pricingSummary && !!pricingSummary.variantId;
  const showPriceDetailsButton = service.disablePriceDetails == false;

  const totalPrice = showPricingSummary
    ? calculateTotalPrice(pricingSummary)
    : "";

  return (
    <FourthStepInfoContainer higherZIndex>
      {displayHeading && (
        <h2>
          {isWaitlist
            ? "Registrert!"
            : fourthStepLabels?.appointmentDetailsHeading}
        </h2>
      )}
      <div className="d-flex flex-column">
        <p className="mt-0">{specialization.name}</p>
        <p className="my-0 font-weight-semi-bold">
          {waitlist
            ? waitlist.serviceName
            : service.bookingName ?? service.name}
        </p>
        <p className="my-0">
          {!waitlist && <>{formattedDate}</>}
          {!waitlist && `, kl. ${format(appointmentStartTime, "HH:mm")}`}
        </p>
        <p className="mt-0">{center.name}</p>
        {!waitlist && (
          <>
            <div>
              {!!doctor && !doctor.isNotADoctor && (
                <>
                  {"Hos "}
                  <a
                    className="mb-2 font-weight-semi-bold"
                    href={doctor?.doctorUrl}
                  >
                    <span className="underline">{doctor?.name ?? ""}</span>
                  </a>
                  {service.showDoctorsJobTitle && !!doctor.jobTitle && (
                    <span className="fs-6 hourPicker__doctor-title">
                      {doctor.jobTitle}
                    </span>
                  )}
                </>
              )}
              {showPricingSummary && (
                <p>
                  {!pricingSummary.listWithoutPrice && (
                    <span className="pe-1">
                      {!!pricingSummary.campaignPrice
                        ? "Kampanjepris:"
                        : "Pris:"}{" "}
                      {totalPrice.toLocaleString("nb")}
                      ,-
                    </span>
                  )}
                  {showPriceDetailsButton && (
                    <PriceDetailsButton
                      service={service}
                      bookingLabels={bookingLabels!}
                      buttonCss={"btn fw-normal fs-5 p-0 btn-link"}
                      onClick={() => setShowPricingSummaryModal(true)}
                    />
                  )}
                </p>
              )}
            </div>
            <CancellationMessage message={cancellationMessage} />
            <div className="mb-1">
              {/*DISABLED FOR LAUNCH*/}
              {/*<AddToCalendar*/}
              {/*  service={service}*/}
              {/*  startTime={appointmentStartTime}*/}
              {/*  endTime={appointmentEndTime}*/}
              {/*  location={center}*/}
              {/*/>*/}
            </div>
          </>
        )}
      </div>
      {showPricingSummary && (
        <PricingSummaryModal
          onClose={() => setShowPricingSummaryModal(false)}
          isOpen={showPricingSummaryModal}
          pricingSummary={pricingSummary}
          Modal={modal}
        />
      )}
    </FourthStepInfoContainer>
  );
};
